const localCloudFrag = `
uniform vec2 resolution;
uniform float time;
uniform float showFactor;
uniform float opacity;
uniform sampler2D tDiffuse;
uniform sampler2D tCloud;
uniform sampler2D tNoise;
varying vec2 vUv;

void main() {
    vec2 uv = vUv;
    vec3 col = texture2D(tDiffuse, uv).rgb;

    float hf = 1.0 - showFactor;
    if (uv.y < 0.5) {
      uv.y = min(0.5, uv.y + mod(hf*0.25, 0.5));
    } else {
      uv.y = max(0.5, uv.y - mod(hf*0.25, 0.5));
    }

    uv.x -= time*0.01;


    float n1 = texture2D(tNoise, uv + time *0.02).r;
    float n2 = texture2D(tNoise, uv * 2.0 + time *0.05).r;
    float n3 = texture2D(tNoise, uv * 4.0 + time *0.1).r;
    float n = n1 * 0.65 + n2 * 0.3 + n3 * 0.15;

    float n4 = texture2D(tNoise, uv * 2.0 + time *0.04).r;
    float n5 = texture2D(tNoise, uv * 1.0 + time *0.02).r;
    uv += n4 * 0.01 + n5 * 0.005;

    vec3 cloudCol = texture2D(tCloud, uv).rgb;
    cloudCol *= n;
    cloudCol = pow(cloudCol, vec3(0.6));
    // cloudCol *= pow(showFactor, 10.0);
    cloudCol *= 2.0 * opacity;

    col = mix(col, vec3(1.0), vec3(cloudCol.r));

    gl_FragColor = vec4(col, 1.0);
}
`;
export default localCloudFrag;
